<template>
    <div class="page">
        <img class="bg_blue" src="../assets/images/bg_blue.png" alt="">
        <div class="page_content people_page">
            <div class="page_title" data-aos="fade-down" data-aos-duration="500">{{text.title[lang]}}</div>
            <div class="subtitle" data-aos="fade-down" data-aos-duration="600">{{text.subtitle[lang]}}</div>
            <div class="img_container">
                <div class="img_column">
                    <div class="img_1" data-aos="fade-down" data-aos-duration="500" data-aos-delay="100">
                        <img class="img_base" src="../assets/images/photo_4.jpg" alt="">
                    </div>
                    <div class="img_2" data-aos="fade-down" data-aos-duration="600" data-aos-delay="50">
                        <img class="img_base" src="../assets/images/photo_2.jpeg" alt="">
                    </div>
                </div>
                <div class="img_column">
                    <div class="img_3" data-aos="fade-down" data-aos-duration="800" data-aos-delay="0">
                        <img class="img_base" src="../assets/images/photo_1.jpg" alt="">
                    </div>
                    <div class="img_4" data-aos="fade-down" data-aos-duration="600" data-aos-delay="100">
                        <img class="img_base" src="../assets/images/photo_5.jpg" alt="">
                    </div>
                    <div class="img_5" data-aos="fade-down" data-aos-duration="500" data-aos-delay="50">
                        <img class="img_base" src="../assets/images/photo_6.jpg" alt="">
                    </div>
                </div>
            </div>
            <div class="brief_intro" data-aos="fade-down" data-aos-duration="500">{{text.briefIntro[lang]}}</div>
            <div class="page_subtitle" data-aos="fade-down" data-aos-duration="600">{{text.subtitle2[lang]}}&emsp;&gt;</div>
            <div class="middle1">
                <div class="speciality_box" data-aos="fade-down" data-aos-duration="500">
                    <div class="speciality_item" v-for="(item, index) in text.speciality" :key="index">
                        <div class="speciality_content">
                            <div class="speciality_icon">
                                <img class="img_base" :src="item.icon" alt="">
                            </div>
                            <div class="spciality_text">{{item.content[lang]}}</div>
                        </div>
                        
                        <div class="spciality_no">{{item.no}}</div>
                    </div>
                </div>
            </div>
            <div class="middle2">
                <div class="left_bg"></div>
                <div class="right_bg"></div>
                <div class="people_box" data-aos="fade-down" data-aos-duration="500">
                    <div class="people_container mt-20">
                        <div :class="{'people_item': true, 'turn_grey': peopleIndex !== null && index !== peopleIndex}" v-for="(item, index) in text.members.slice(0, 4)" :key="index">
                            <div class="people_img">
                                <img class="img_base" :src="item.img" alt="">
                            </div>
                            <div class="people_name">{{item.name[lang]}}</div>
                            <div class="people_pos">{{item.pos[lang]}}</div>
                            <button class="btn_plus" @click="onOpenPeopleInfo(index)">+</button>
                        </div>
                    </div>
                </div>
                <transition name="slide">
                    <div class="people_info" v-if="peopleIndex !== null">
                        <div class="people_info_box">
                            <div class="people_info_name">{{text.members[peopleIndex].name[lang]}}</div>
                            <div class="people_info_pos">{{text.members[peopleIndex].pos[lang]}}</div>
                            <div class="people_info_intro">{{text.members[peopleIndex].intro[lang]}}</div>
                        </div>
                        <div class="people_info_img">
                            <img class="img_base" :src="text.members[peopleIndex].img2" alt="">
                        </div>
                        <button class="btn_close" @click="onClosePeopleInfo">×</button>
                    </div>
                </transition>
                <div class="people_box" data-aos="fade-down" data-aos-duration="500">
                    <div class="people_container mb-10">
                        <div :class="{'people_item': true, 'turn_grey': peopleIndex !== null && index + 4 !== peopleIndex}" v-for="(item, index) in text.members.slice(4)" :key="index">
                            <div class="people_img">
                                <img class="img_base" :src="item.img" alt="">
                            </div>
                            <div class="people_name">{{item.name[lang]}}</div>
                            <div class="people_pos">{{item.pos[lang]}}</div>
                            <button class="btn_plus" @click="onOpenPeopleInfo(index + 4)">+</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Foot/>
        <Nav navstyle="dark"></Nav>
    </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import Foot from '@/components/Foot.vue'
import {peopleText} from '@/js/text.js'
import {wxShare} from '@/js/api.js'
export default {
    components: {
        Nav,
        Foot
    },
    data () {
        return {
            text: peopleText,
            peopleIndex: null
        }
    },
    computed: {
        lang () {   // 0中文，1英文
            return this.$store.state.lang
        }
    },
    methods: {
        onClosePeopleInfo () {
            this.peopleIndex = null
        },
        onOpenPeopleInfo (index) {
            // if (this.peopleIndex !== null && index !== this.peopleIndex) return
            this.peopleIndex = index
        }
    },
    mounted () {
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '用户', '进入', '关于我们-团队'])
        const url = location.href
        var shareInfo = {
            title: '了解我们的团队',
            desc: '这是一个因挑战而兴奋的团队'
        }
        wxShare(url, shareInfo)
    }
}
</script>

<style scoped>
.bg_blue {
    width: 100%;
    height: 58vw;
}
.people_page {
    width: 100%;
    margin-top: -58vw;
}
.page_title {
    width: 100%;
    padding: 5% 20%;
    font-size: 2.25rem;
    font-weight: 500;
    line-height: 1.5;
    margin-top: 10%;
    box-sizing: border-box;
}
.subtitle {
    width: 60%;
    font-size: 1.125rem;
    /* font-weight: bold; */
    line-height: 1.5;
    margin: 0 20% 5% 20%;
}
.img_container {
    width: 80vw;
    margin: 0 10%;
    display: flex;
    justify-content: space-between;
}
.img_column {
    width: 39vw;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.img_column div {
    margin-bottom: 2vw;
    background: #B6ADB4;
}
.img_1 {
    width: 32vw;
    height: 32vw;
    margin-top: 3vw;
}
.img_2 {
    width: 39vw;
    height: 40vw;
}
.img_3 {
    width: 39vw;
    height: 32vw;
}
.img_4 {
    width: 39vw;
    height: 40vw;
}
.img_5 {
    width: 37vw;
    height: 20vw;
}
.page_subtitle {
    width: 80%;
    margin: 0 10% 2% 10%;
    border-top: solid #A1A1A1 1px;
    font-size: 0.875rem;
    line-height: 2rem;
    text-align: left;
    white-space: pre;
}
.brief_intro {
    width: 39vw;
    text-align: left;
    font-size: 1.125rem;
    line-height: 1.5;
    margin: -20vw auto 15% 10%;
}
.middle1 {
    width: 100%;
    position: relative;
    height: 20vw;
    /* background: #D8D8D8; */
}
.speciality_box {
    width: 80vw;
    min-height: 20vw;
    background: #F4FAFF;
    left: 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 0;
    z-index: 1;
}
.speciality_item {
    width: 20vw;
    box-sizing: border-box;
    min-height: 16vw;
    position: relative;
    padding: 2vw 2vw 1vw 2vw;
}
.speciality_item + .speciality_item {
    border-left: 1px solid #d5d5d5;
}
.speciality_content {
    width: 100%;
}
.speciality_icon {
    width: 7vw;
    height: 7vw;
    margin-left: 2vw;
    overflow: hidden;
}
.spciality_no {
    position: absolute;
    top: 0;
    right: 2vw;
    font-size: 1.125rem;
    line-height: 1.5;
}
.spciality_text {
    width: 16vw;
    margin-top: 10%;
    right: 2vw;
    font-size: 1.125rem;
    line-height: 1.2;
    /* font-weight: bold; */
}
.middle2 {
    width: 100%;
    background: linear-gradient(0.02turn, #444C71, #4C5376);
    margin-top: -10%;
    box-sizing: border-box;
    /* padding: 20% auto 10% auto; */
    position: relative;
}
/* .left_bg {
    width: 10vw;
    height: 20;
} */
.people_box {
    width: 80%;
    margin-left: 10%;
    overflow: hidden;
}
.people_container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}
.people_item {
    width: 18.5vw;
    height: 18.5vw;
    background: #5F678C;
    position: relative;
    margin-bottom: 2vw;
}
.people_item + .people_item {
    /* margin-left: 2vw; */
}
.people_img {
    width: 9vw;
    height: 9vw;
    background: #fff;
    border-radius: 100%;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.people_name {
    font-size: 1.125rem;
    color: #fff;
    font-weight: bold;
    line-height: 1.5;
    max-width: 14vw;
    position: absolute;
    bottom: 0.2rem;
    left: 0.5rem;
}
.people_pos {
    font-size: 0.875rem;
    line-height: 1.5;
    color: #fff;
    font-weight: bold;
    /* max-width: 20vw; */
    position: absolute;
    top: 0.2rem;
    right: 0.5rem;
    text-align: right;
}
.btn_plus {
    width: 3.5vw;
    height: 3.5vw;
    line-height: 3.5vw;
    font-size: 3vw;
    font-weight: lighter;
    text-align: center;
    color: #5F678C;
    position: absolute;
    bottom: 0;
    right: 0;
}
.slide-enter-active, .slide-leave-active {
  transition: all .3s ease;
}
.slide-leave-active {
    transition: all 0s ease;
}
.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: scaleY(0);
}
.people_info {
    width: 80%;
    margin: 1vw auto 3vw auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30vw;
    position: relative;
    transform-origin: center top;
}
.people_info_box {
    width: 68%;
    height: 100%;
    border-top: 1px solid #d5d5d5;
    border-bottom: 1px solid #d5d5d5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 1.5;
    color: #fff;
    text-align: left;
}
.people_info_name {
    width: 100%;
    font-size: 1.125rem;
    font-weight: bold;
}
.people_info_pos {
    width: 100%;
    font-size: 0.875rem;
    margin: 2% auto;
}
.people_info_intro {
    width: 100%;
    font-size: 0.875rem;
}
.people_info_img {
    width: 30%;
    height: 100%;
    background: #D8D8D8;
}
.btn_close {
    width: 3.5vw;
    height: 3.5vw;
    line-height: 3.5vw;
    font-size: 3vw;
    text-align: center;
    color: #5F678C;
    position: absolute;
    top: 0;
    right: 0;
}
.turn_grey {
    opacity: 0.5;
}
@media screen and (max-width: 756px) {
    .people_name {
        font-size: 0.875rem;
    }
    .people_pos {
        font-size: 0.75rem;
    }
    .people_info {
        width: 80%;
        flex-direction: column-reverse;
        justify-content: flex-start;
        height: auto;
    }
    .people_info_box {
        width: 100%;
    }
    .people_info_img {
        width: 100%;
        height: 50vw;
        background: #D8D8D8;
        margin-bottom: 2vw;
    }
    .people_info_name {
        margin-top: 5%;
    }
    .people_info_intro {
        margin-bottom: 10%;
    }
    .people_container {
        flex-flow: wrap;
    }
    .people_item {
        width: 37vw;
        height: 37vw;
        margin-bottom: 4vw;
    }
}
</style>
